import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { AuthStore } from '@app/@core/auth/auth.store';
import { environment } from '@env/environment';
import { EffectsModule } from '@ngrx/effects';
import { RouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AuthEffects } from './auth/auth.effects';
import { reducers } from './core.state';
import { AuthTokenInterceptor } from './interceptor/auth-token.interceptor';
import { LoaderInterceptor } from './interceptor/loader.interceptor';
import { CustomSerializer } from './router/custom-serializer';
import { RoutePermissionResolver } from './router/route-permission.resolver';
import { PermissionStore } from './store/permission.store';
import { TermsConditionsComponent } from './auth/terms-conditions/terms-conditions.component';
import { PrivacyPolicyComponent } from './auth/privacy-policy/privacy-policy.component';
import { PrivacyTermsComponent } from './auth/privacy-terms/privacy-terms.component';

@NgModule({
  imports: [
    CommonModule,
    // ngrx
    StoreModule.forRoot(reducers, {}),
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forRoot([AuthEffects]),
    environment.production ? [] : StoreDevtoolsModule.instrument({ name: 'GA-Medicaid' })
  ],
  providers: [
    RoutePermissionResolver,
    PermissionStore,
    AuthStore,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthTokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    },
    { provide: RouterStateSerializer, useClass: CustomSerializer }
  ],
  declarations: [
    TermsConditionsComponent,
    PrivacyPolicyComponent,
    PrivacyTermsComponent
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    // Import guard
    if (parentModule) {
      throw new Error(`${parentModule} has already been loaded. Import Core module in the AppModule only.`);
    }
  }
}
